import { Dashboard } from './Dashboard';
import { LoginPage } from './LoginPage';
import { useAuth } from './auth';

export function App() {
  const { token } = useAuth();
  return token ? <Dashboard /> : <LoginPage />;
}
